import React, {useState, useEffect} from 'react';
import Chip from '@mui/material/Chip';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppBadIcon from '@mui/icons-material/GppBad';
import styled from 'styled-components';
import { FlashOnRounded } from '@mui/icons-material';


function ChipInsurance({ withInsurance }) {

const CustomChip = styled(Chip)`
    text-transform: none;
    font-weight: 500;
    position: absolute;
    top: -12.5px;
    left: 5px;
    font-size: 0.75rem;
    height: 25px;
    color: white;
    background-color: ${withInsurance ? "green": "#c75a5a"};
  `;


  return (
    <CustomChip
      size="medium"
      icon={
        withInsurance ? (
          <GppGoodIcon
            style={{ color: 'white', height: 15, width: 15, marginLeft: 10 }}
          />
        ) :  (
          <GppBadIcon
            style={{ color: 'white', height: 15, width: 15, marginLeft: 10 }}
          />
        )
      }
      label={withInsurance ? "Com Seguro" : "Sem Seguro"}
    />
  );
}

export default ChipInsurance;
